import * as z from "zod";
import {TaxAccountantVisitHistoryModel} from "./TaxAccountantVisitHistoryModel";

const schema = z.object({
	registeredTaxAccountantVisitHistoryResponses: z.array(TaxAccountantVisitHistoryModel.model),
	managedTaxAccountantVisitHistoryResponses: z.array(TaxAccountantVisitHistoryModel.model)
});

const model = schema.transform((values) => ({
	...values
}));

export const ReportTwoResModel = {schema, model};
export type IReportTwoResModel = z.infer<typeof ReportTwoResModel.model>;
export const DEFAULT_REPORT_TWO_RES: IReportTwoResModel = {
	registeredTaxAccountantVisitHistoryResponses: [],
	managedTaxAccountantVisitHistoryResponses: []
};
